{
  "salon-details-header": {
    "buttons": {
      "link-copied": "LINK COPIED",
      "share": "SHARE",
      "visit-virtually": "VISIT THE SALON VIRTUALLY"
    }
  }
}
